import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "styles/scss/main.scss";
import reportWebVitals from "./reportWebVitals";
import { LayoutProvider } from "context/Layout/Provider";
import { UserProvider } from "context/User/Provider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <UserProvider>
      <LayoutProvider>
        <App />
      </LayoutProvider>
    </UserProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
